import { render } from "./Patologias.vue?vue&type=template&id=3add8a6e&scoped=true"
import script from "./Patologias.vue?vue&type=script&lang=js"
export * from "./Patologias.vue?vue&type=script&lang=js"

import "./Patologias.vue?vue&type=style&index=0&id=3add8a6e&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3add8a6e"]])

export default __exports__